import RoomSceneList from '../RoomSceneList/RoomSceneList';
import TopMenu from '../TopMenu/TopMenu';
import background from './assets/background.png';
import styles from './RoomscenePage.module.css'

export default function RoomScenePage() {
    return (
        <>
            <TopMenu extended={false} page='roomscenes'/>
            
            <section className={styles.roomsceneSection}>
            <div className={styles.content}>
                <h2>Envision the possibilites</h2>
                <h3>Choose an Image to  get started</h3>
                <RoomSceneList seriesId="8554" thumbnailSize={600} />
                </div>
            </section>
        </>
    );
}